import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
} from '@ey-xd/motif-react';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';

const SecuritiesSnapshotHeader = ({
  handleExportSecuritiesQuarterlyData,
  handleUploadSecuritiesQuarterlyData,
}) => {
  const [actionOptionsOpen, setActionOptionsOpen] = useState(false);

  return (
    <div className="row mt-3">
      <div className="col-md-2"> </div>
      <div className="col-md-10 d-flex justify-content-end">
        <div style={{ width: 'fit-content' }}>
          <MotifDropdown
            open={actionOptionsOpen}
            placement="bottom-end"
            id={'action-dropdown'}
            className="securities-snapshot-dropdown-action"
            handleClickOutside={() => setActionOptionsOpen(false)}
            trigger={
              <MotifButton
                type="button"
                variant="primary"
                onClick={() => setActionOptionsOpen(!actionOptionsOpen)}
                aria-controls={'action-dropdown'}
                id={'action-dropdown-trigger'}
                aria-expanded={actionOptionsOpen}
                aria-label="Action dropdown"
                data-testid="btnActions"
              >
                Actions{' '}
                <MotifIcon
                  iconFunction={IconoirNavArrowDown}
                  size="24"
                  fill="none"
                />
              </MotifButton>
            }
          >
            <ul role="menu">
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleExportSecuritiesQuarterlyData}
                  data-testid="btnExportSecuritiesQuarterlyData"
                  className="master-dropdown-item"
                >
                  Export Securities Quarterly Data
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleUploadSecuritiesQuarterlyData}
                  data-testid="btnUploadSecuritiesQuarterlyData"
                  className="master-dropdown-item"
                >
                  Upload Securities Quarterly Data
                </MotifDropdownItem>
              </li>
            </ul>
          </MotifDropdown>
        </div>
      </div>
    </div>
  );
};

SecuritiesSnapshotHeader.propTypes = {
  handleExportSecuritiesQuarterlyData: PropTypes.func.isRequired,
  handleUploadSecuritiesQuarterlyData: PropTypes.func.isRequired,
};

export default SecuritiesSnapshotHeader;
